import { themeQuartz, iconSetMaterial } from "ag-grid-community";

// to use myTheme in an application, pass it to the theme grid option
const myTheme = themeQuartz.withPart(iconSetMaterial).withParams({
  backgroundColor: "#FFFFFF",
  browserColorScheme: "light",
  cellTextColor: "#000000",
  borderColor: "FCFCFC",
  borderWidth: 2,
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxBorderWidth: 1,
  checkboxUncheckedBorderColor: "#CCCCCC",
  chromeBackgroundColor: "#28598B",
  foregroundColor: "#2c3e50",
  headerFontSize: 14,
  headerTextColor: "#FFFFFF",
  inputFocusTextColor: "#000000",
  inputTextColor: "#000000",
  oddRowBackgroundColor: "#F3F5F5CC",
});

export default myTheme;

const colors = [
  "rgba(214, 234, 248, 0.4)", // bleu clair
  "rgba(213, 245, 227, 0.4)", // vert clair
  "rgba(252, 243, 207, 0.4)", // jaune clair
  "rgba(250, 219, 216, 0.4)", // rouge rosé
  "rgba(232, 218, 239, 0.4)", // violet clair
];

export const getColumnColor = (index: number) => {
  return colors[index % colors.length];
};
